export default __webpack_public_path__ + "static/media/Vorschau-wird-vorbereitet.cd1b148b.mp4";